<script setup lang="ts">
import { computed } from "vue";
import type { IProductDetailsParametersBaseProps } from "../types/product-details";
import VMarkedText from "@magnit/core/src/components/VMarkedText/VMarkedText.vue";
import { SCHEMA_ORG_PRODUCT_PROPS_MAP } from "../constants/schemaorg";

const props = defineProps<IProductDetailsParametersBaseProps>();
const text = computed(() => props.parameters?.[0].value);
</script>

<template>
  <section v-if="text" class="product-details-parameters-flat">
    <VMarkedText
      :text="text"
      :itemprop="SCHEMA_ORG_PRODUCT_PROPS_MAP[parameters?.[0].name]"
    />
  </section>
</template>
